import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';

import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import QRCode from 'qrcode.react';
import GetAppIcon from '@mui/icons-material/GetApp';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import mergeImages from 'merge-images';

import { useSelector } from 'react-redux';

import QrCodeSettings from './QrCodeSettings';

const useStyles = makeStyles((theme) => ({

    root: {
        flexGrow: 1,
        padding: theme.spacing(2)
    },
    card: {
        display: 'flex',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: 151,
        height: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));


const RestaurantQRCode = (props) => {
    const classes = useStyles();

    const { restaurantId, item, tableNumber, updateQRCodeSetting, expiresTimestamp, formatExpireTime } = props;
    const [useBlackTemplate, setUseBlackTemplate] = useState(false);

    const restaurant = useSelector((state) => state.restaurant.selectedRestaurant);

    const getTemplateName = (name) => {
        if (!(['pickup-delivery', 'takeaway', 'pickup', 'delivery'].includes(name))) {
            return 'dinein';
        } else {
            return name;
        }
    };

    const merge = (id) => {
        const imageNamePrefix = getTemplateName(item.name);
        const templateName = (imageNamePrefix === 'dinein' && useBlackTemplate)
            ? 'dinein-template-black'
            : `${imageNamePrefix}-template`;
        var resizedCanvas = document.createElement("canvas");
        var resizedContext = resizedCanvas.getContext("2d");
        let size = 602;
        let x = 326;
        let y = 378;
        if (imageNamePrefix === 'dinein') {
            size = 420;
            x = 263;
            y = useBlackTemplate ? 496 : 310;
        }
        resizedCanvas.height = size;
        resizedCanvas.width = size;
        const canvas = document.getElementById(id);
        resizedContext.drawImage(canvas, 0, 0, size, size);

        const pngUrl = resizedCanvas.toDataURL("image/png")


        mergeImages([{ src: `/static/images/${templateName}.png`, x: 0, y: 0 }, { src: pngUrl, x: x, y: y }])
            .then(b64 => {
                let downloadCanvas = document.getElementById(`canvas-${item.name}`);
                downloadCanvas.setAttribute('id', `canvas-${item.name}`);
                if (imageNamePrefix === 'dinein') {
                    downloadCanvas.width = 946;
                    downloadCanvas.height = 1312;
                } else {
                    downloadCanvas.width = 1240;
                    downloadCanvas.height = 1754;
                }

                var ctx = downloadCanvas.getContext("2d");
                var image = new Image();

                image.src = b64;
                image.onload = function () {
                    let nameX = 473;
                    let nameY = 1530;
                    let altNameX = 429;
                    let altNameY = 1600;
                    let midX = 620;
                    ctx.drawImage(image, 0, 0);
                    if (tableNumber) {
                        midX = 463;
                        ctx.font = "60pt Calibri";
                        ctx.fillStyle = "#FFFFFF";
                        ctx.textAlign = "center";
                        ctx.fillText(useBlackTemplate ? `Table ${tableNumber}` : tableNumber, useBlackTemplate ? 473 : 660, useBlackTemplate ? 990 : 906);

                        nameX = 427;
                        nameY = 1020;
                        altNameX = 427;
                        altNameY = 1080;

                    }

                    if (!useBlackTemplate && restaurant && restaurant.name && restaurant.name.trim() !== '') {
                        ctx.font = "40pt Calibri";
                        ctx.fillStyle = "#FFFFFF";
                        ctx.textBaseline = 'middle';
                        ctx.textAlign = "center";

                        ctx.fillText(restaurant.name, midX, nameY);


                    }

                    if (!useBlackTemplate && restaurant && restaurant.altName && restaurant.altName.trim() !== '') {
                        ctx.font = "40pt Calibri";
                        ctx.fillStyle = "#FFFFFF";
                        ctx.textBaseline = 'middle';
                        ctx.textAlign = "center";
                        ctx.fillText(restaurant.altName, midX, altNameY);

                    }


                    downloadQRType(`canvas-${item.name}`);
                };

                // setBase64(b64)
            });
    }

    const downloadPickupQR = () => {
        merge(item.name);
    };

    const downloadQRType = (id) => {
        // console.log('id', id);
        const canvas = document.getElementById(id);
        const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${restaurantId}-${item.name}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    const getQRCodeValue = (item) => {
        if (item.shortUrl) {
            return item.shortUrl;
        }

        if (!restaurant) {
            return '';
        }

        const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
        const host = window.location.port
            ? `${window.location.hostname}:${window.location.port}`
            : window.location.hostname;

        if (item.name === 'booking' || item.name === 'queue') {
            return `${protocol}://${host}/${item.code}/${encodeURI(restaurantId)}`;
        } else {
            const urlString = `${protocol}://${host}/online/${encodeURI(restaurantId)}/${item.code}`;
            if (!restaurant.qrCodeTypes || restaurant.qrCodeTypes.length === 0) {
                return urlString;
            }
            const filterResult = restaurant.qrCodeTypes.filter((code) => {
                return code === item.name;
            });

            if (!filterResult || filterResult.length === 0) {
                return urlString;
            }
            const newRestaurantId = `${restaurantId}_${item.name}`;

            return `${protocol}://${host}/online/${encodeURI(newRestaurantId)}/${item.code}`;

        }
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

    return (
        <div className={classes.root}>
            <Grid>
                <Paper className={classes.paper} >
                    <Typography component="h5" variant="h5">
                        {capitalizeFirstLetter(item.name)} QR Code
                    </Typography>
                    {(expiresTimestamp || item?.expiresTimestamp) && (
                        <Typography variant="body1" color="textSecondary" style={{ marginTop: 8, marginBottom: 8 }}>
                            Expires: {formatExpireTime ? formatExpireTime(expiresTimestamp || item?.expiresTimestamp) : new Date(expiresTimestamp || item?.expiresTimestamp).toLocaleString()}
                        </Typography>
                    )}
                    {!item.shortUrl && (
                    <QrCodeSettings name={item.name} updateQRCodeSetting= {updateQRCodeSetting}/>
                    )}

                    {getTemplateName(item.name) === 'dinein' && tableNumber && (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={useBlackTemplate}
                                    onChange={(e) => setUseBlackTemplate(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Use black background template"
                        />
                    )}

                    <div className={classes.controls}>
                        <IconButton aria-label="download" onClick={downloadPickupQR}>
                            <GetAppIcon /> <a> Download </a>
                        </IconButton>

                        <canvas id={`canvas-${item.name}`}></canvas>

                    </div>


                    <div>


                        <QRCode
                            id={item.name}
                            value={getQRCodeValue(item)}
                            size={280}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"H"}
                            includeMargin={true}
                            imageSettings={{
                                src: "/static/images/orderbuddy.jpeg",
                                x: null,
                                y: null,
                                height: 28,
                                width: 28,
                                excavate: true,
                            }}
                        />


                    </div>
                    <a href={getQRCodeValue(item)} target="_blank">{`Click here to open URL`}</a>

                </Paper>


            </Grid>
        </div>
    );
}


export default RestaurantQRCode;